import { useCookie, readonly } from '#imports';

/**
 * useCookie Must be called within composable setup.
 * To update cookies, this useSessionCookies composable returns callback methods to update cookie.value
 * This composable is called via plugin to bind to the nuxtApp instance - call actions via `const { $sessionCookies } = useNuxtApp()`
 */
export const useSessionCookies = () => {
  const wooSessionCookie = useCookie('woo-session', {
    default: () => '',
  })

  const userSelectedCurrencyCookie = useCookie('aelia_cs_selected_currency', {
    default: () => 'USD',
  })

  const userSelectedCountryCookie = useCookie('aelia_customer_country', {
    default: () => 'US',
  })

  const userShowTaxCookie = useCookie('user_show_tax', {
    default: () => false,
  })

  const userHideNewsletterSignupCookie = useCookie('user_hide_newsletter_signup', {
    default: () => false,
    maxAge: 60 * 60 * 24 * 30, // 30 days
  })

  return {
    // Getters for cookie values - access with .value
    wooSession: readonly(wooSessionCookie),
    userSelectedCurrency: readonly(userSelectedCurrencyCookie),
    userSelectedCountry: readonly(userSelectedCountryCookie),
    userShowTax: readonly(userShowTaxCookie),
    userHideNewsletterSignup: readonly(userHideNewsletterSignupCookie),

    // Update methods
    update_woo_session: (newValue) => {
      wooSessionCookie.value = newValue
    },

    update_user_show_tax: (newValue) => {
      userShowTaxCookie.value = newValue
    },

    update_user_hide_newsletter_signup: (newValue) => {
      userHideNewsletterSignupCookie.value = newValue
    },

    clear_all_session: () => {
      wooSessionCookie.value = ''
      userSelectedCurrencyCookie.value = 'USD'
      userSelectedCountryCookie.value = 'US'
      userShowTaxCookie.value = false
      userHideNewsletterSignupCookie.value = false
    }
  }
}
